import { render, staticRenderFns } from "./CustomerIncreaseLimit.vue?vue&type=template&id=0afb0a76"
import script from "./CustomerIncreaseLimit.vue?vue&type=script&lang=js"
export * from "./CustomerIncreaseLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports